<template>
  <aside v-if="chatData != false" v-click-outside="hideChatMenu">
    <div class="chat d-flex align-items-start flex-column">
      <div class="chat-header p-2">
        <span>{{ $t("TALK") }}</span>
        <a href="#" v-on:click.prevent="hideChatMenu" class="pull-right"
          ><img src="../assets/img/icon-close.svg" alt=""
        /></a>
      </div>
      <div
        ref="messageDisplay"
        class="chat-container d-flex align-content-end mb-auto"
      >
        <div class="inner">
          <div
            class="row chat-single-message"
            v-for="message in reverseMessages"
          >
            <div class="col-md-6 users">
              <span
                v-bind:class="globals.userId == message.userId ? 'green' : ''"
                >{{ message.name }} {{ message.surname }}
                <span v-if="globals.userId == message.userId"
                  >({{ $t("ME") }})</span
                ></span
              >
              <img src="../assets/img/chat-user-flow-pointer.svg" alt="" />
              {{ message.toName }} {{ message.toSurname }}
            </div>
            <div class="col-md-6 time">{{ formatDate(message.dateTime) }}</div>
            <div class="col-12 message">{{ message.text }}</div>
          </div>
        </div>
      </div>
      <div class="chat-input">
        <div class="row">
          <div class="form-group col-12">
            <textarea
              class="form-control secondary"
              v-model="chatMessage"
              v-focus
              v-on:keyup.enter="sendMessage"
            ></textarea>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12">
            <a class="btn btn-primary" v-on:click="sendMessage">{{
              $t("SEND")
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@/api/workordertalks";
var moment = require("moment");

export default {
  name: "Chat",
  data: function () {
    return {
      chatMessage: "",
      messages: {
        root: [],
        totalCount: 0,
        basicData: {},
      },
      interval: false,
    };
  },
  computed: {
    ...mapGetters(["chatData", "globals"]),
    reverseMessages() {
      return this.messages.root.slice().reverse();
    },
  },
  watch: {
    chatData() {
      var me = this;
      me.getChat();
    },
  },
  methods: {
    ...mapActions(["selectMyMessageCount"]),
    formatDate(dateTime) {
      return moment(dateTime).format("DD.MM.YYYY HH:mm");
    },
    sendMessage() {
      var me = this;

      const params = {
        toUserId: me.chatData.chatUserId,
        text: me.chatMessage,
      };

      if (me.chatData.workOrderId) {
        params.workOrderId = me.chatData.workOrderId;
      }

      if (me.chatData.dentalSolutionId) {
        params.dentalSolutionId = me.chatData.dentalSolutionId;
      }

      api.insertTalk(params, function (data) {
        if (data.error && data.error == true) {
          me.$notify.error(data.notice);
          return;
        }
        me.getChat();
        me.chatMessage = "";
      });
    },
    getChat() {
      var me = this;
      if (me.interval !== false) {
        clearInterval(me.interval);
      }

      if (me.chatData == false) return;

      me.interval = setInterval(function () {
        api.selectChat(me.chatData, function (data) {
          if (data.error && data.error == true) {
            me.$notify.error(data.notice);
            return;
          }
          me.messages = data;
          me.scrollToBottom();
          me.selectMyMessageCount();
        });
      }, 1000);
    },
    hideChatMenu: function () {
      this.messages.root = [];
      this.messages.totalCount = 0;
      this.$store.commit("hideChatMenu");
    },
    scrollToBottom() {
      var me = this;
      setTimeout(function () {
        var messageDisplay = me.$refs.messageDisplay;
        messageDisplay.scrollTop = messageDisplay.scrollHeight;
      }, 10);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Chat.vue